export class BtmPaymentMethodModel {
    fan: string;
    ban: string;
    billingCTN: string;

    constructor() {
        this.fan = undefined;
        this.ban = undefined;
        this.billingCTN = undefined;
    }
}
